module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style6/ecommerce-header-style6.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style6/ecommerce-header-style6.component.scss
// module chunks = main